/* Mi & My concern quiz.
   Questions/answers are editable in the theme editor. This file is the logic
   that maps answers to recommendations — carried over from the approved
   design. Each recommendation key (wetpops, bigo, …) is a "Product slot" block
   whose product picker supplies the live product, price and stock. */
(function(){
  var modal = document.getElementById('qzModal');
  var scrim = document.getElementById('qzScrim');
  var fill = document.getElementById('qzFill');
  var dataEl = document.getElementById('qzData');
  if(!modal || !dataEl) return;
  var D = JSON.parse(dataEl.textContent);
  var S = D.slots || {};
  var money = function(c){ return (window.MM && MM.money) ? MM.money(c) : '$' + (c/100).toFixed(2); };

  var answers = {1:[],2:[],3:[],4:[]};

  function show(n){
    modal.querySelectorAll('.qz-step').forEach(function(s){ s.classList.toggle('on', +s.dataset.step === n); });
    if(fill) fill.style.width = (n/5*100) + '%';
    modal.scrollTop = 0;
  }
  function open(){ modal.hidden = false; scrim.hidden = false; show(1); }
  function close(){ modal.hidden = true; scrim.hidden = true; }

  modal.querySelectorAll('.qz-step').forEach(function(step){
    var n = +step.dataset.step;
    var opts = step.querySelector('.qz-opts');
    var multi = opts && opts.dataset.multi;
    step.querySelectorAll('.qz-opt').forEach(function(o){
      o.addEventListener('click', function(){
        if(multi){ o.classList.toggle('sel'); }
        else { step.querySelectorAll('.qz-opt').forEach(function(x){ x.classList.remove('sel'); }); o.classList.add('sel'); }
        answers[n] = Array.prototype.map.call(step.querySelectorAll('.qz-opt.sel'), function(x){ return x.dataset.v; });
      });
    });
  });
  modal.querySelectorAll('[data-next]').forEach(function(b){
    b.addEventListener('click', function(){
      var cur = +b.closest('.qz-step').dataset.step;
      if(!answers[cur].length){ b.textContent = D.pickFirst; setTimeout(function(){ b.textContent = D.next; }, 1200); return; }
      show(+b.dataset.next);
    });
  });
  modal.querySelectorAll('[data-back]').forEach(function(b){
    b.addEventListener('click', function(){ show(+b.dataset.back); });
  });

  function recommend(){
    var c = answers[1], lifeArr = answers[2] || [], when = (answers[3] || [])[0], depth = (answers[4] || [])[0];
    function had(x){ return lifeArr.indexOf(x) > -1; }
    var picks = [], reason = {};
    function add(k, t){ if(picks.indexOf(k) < 0) picks.push(k); if(t && !reason[k]) reason[k] = t; }
    function has(x){ return c.indexOf(x) > -1; }
    var bootyOnly = c.length && c.every(function(x){ return x === 'booty'; });
    var planning = (when === 'before' || when === 'both');
    var quick = !!answers.quick;

    if(has('dry')){
      add('wetpops','<b>Wet Pops</b> are the ones built purely for wetness &mdash; this is what they were made for.');
      add('bomb','<b>Bomb Kitty</b> softens and conditions on the outside. Two drops on warm skin.');
      add('bigo','<b>The Big O</b> brings wetness up along with the grip.');
    }
    if(has('loose'))
      add('bigo','<b>The Big O</b> is the one for tightness &mdash; grip you feel from the first pop.');
    if(has('sens')){
      add('climaxpops','<b>Climaxx Pops</b> work on sensitivity from the inside &mdash; everything turned up.');
      if(planning || quick) add('climaxx','<b>Climaxx Gel</b> is the arousal gel &mdash; warming, and it makes finishing far easier.');
      add('bigo','<b>The Big O</b> covers sensitivity too, alongside tightness and wetness.');
    }
    if(has('odor') || has('taste')){
      add('honey','<b>Sweet Like Honey</b> removes odor and leaves a sweet, natural taste &mdash; this starts with the wash.');
      add('restore','<b>Restore Pops</b> handle it from the inside &mdash; taste and smell track your pH more than anything on the outside.');
    }
    if(has('ph') || had('antibiotics') || had('cycle') || had('birthcontrol') || had('stress') || had('newpartner'))
      add('restore', had('antibiotics')
        ? 'Antibiotics wipe out the good bacteria too. <b>Restore Pops</b> are the reset for the week after.'
        : had('birthcontrol')
        ? 'Starting or stopping birth control moves your hormones, and your pH follows. <b>Restore Pops</b> are the reset.'
        : had('stress')
        ? 'Stress and bad sleep knock your balance sideways more than people realise. <b>Restore Pops</b> put it back.'
        : had('newpartner')
        ? 'More activity changes your pH &mdash; <b>Restore Pops</b> keep it where it belongs.'
        : 'Your balance keeps getting knocked sideways, so <b>Restore Pops</b> belong in your drawer.');
    if(has('booty')){
      if(depth === 'one' || quick) add((has('odor') || when === 'routine') ? 'candy' : 'candyoil', (has('odor') || when === 'routine')
        ? '<b>Candy Cheeks Booty Wash</b> handles odor and upkeep back there.'
        : '<b>Candy Cheeks Booty Oil</b> is the one working on dark spots, bumps and ingrowns.');
      else add('candybun','<b>Candy Cheeks Booty Bundle</b> is the wash and the oil together &mdash; odor, dark spots and bumps, cheaper than buying both.');
    }
    if(had('shaving')){
      add('candyoil','<b>Candy Cheeks Booty Oil</b> calms bumps and ingrowns from shaving &mdash; it works anywhere you get them.');
      add('bomb','<b>Bomb Kitty</b> after you shave keeps skin soft instead of tight and irritated.');
    }
    if(had('birthcontrol') || had('stress'))
      add('bomb','Hormones and stress dry you out on the outside first. <b>Bomb Kitty</b> handles that part.');
    if(when === 'routine' && !quick && !bootyOnly && !had('shaving') && picks.indexOf('honey') < 0)
      add('honey','For an everyday routine, start with a gentle wash &mdash; everything after works better on skin that isn&rsquo;t stripped.');
    if(planning && picks.indexOf('bigo') < 0 && !bootyOnly)
      add('bigo','<b>The Big O</b> is a before product &mdash; one pop when you already know how the night ends.');
    if(had('postpartum'))
      add('bigo','After a baby, most of our girls start with <b>The Big O</b> and give it a full month.');
    if(!picks.length){ add('bigo','<b>The Big O</b> is where most girls start &mdash; our most reviewed product.'); add('honey',''); }

    /* prices in these lines are live, never typed */
    function priced(k){ return S[k] ? money(S[k].price) : ''; }
    function instead(k){ return S[k] && S[k].compare > S[k].price ? ' instead of ' + money(S[k].compare) : ''; }
    if(depth === 'all'){
      if(bootyOnly)
        return {picks:['candybun'], why:'You&rsquo;re after booty care, so the yoni bundle isn&rsquo;t your set. <b>Candy Cheeks Booty Bundle</b> is the wash and the oil together at ' + priced('candybun') + '.'};
      if(c.length && c.every(function(x){ return x === 'loose' || x === 'sens' || x === 'dry'; }))
        return {picks:['explosive'], why:'Tightness, wetness and sensitivity is exactly what <b>The Big O-splosive Bundle</b> is &mdash; Tightening, Climaxx and Wet Pops together for ' + priced('explosive') + instead('explosive') + '.'};
      return {picks:['bundle'], why:'You said you want the full routine, so this is the one. <b>Can I Come Over?! Bundle</b> is all five products in the order you&rsquo;d use them &mdash; ' + priced('bundle') + instead('bundle') + '.'};
    }
    var limit = quick ? 2 : (depth === 'one' ? 1 : (depth === 'few' ? 3 : 2));
    picks = picks.slice(0, limit);
    var why = picks.map(function(k){ return reason[k]; }).filter(Boolean).slice(0, 2).join(' ');
    return {picks:picks, why:why};
  }

  function tpl(k){ return modal.querySelector('template[data-slot="' + k + '"]'); }

  function render(){
    var r = recommend();
    /* only slots with a product picked and in stock can be shown */
    var live = r.picks.filter(function(k){ return tpl(k) && S[k] && S[k].available; });
    if(!live.length){
      ['bigo','honey'].forEach(function(k){ if(tpl(k) && S[k] && S[k].available && live.length < 1) live.push(k); });
      r.why = live.length ? D.noMatch : '';
    }
    document.getElementById('qzTitle').innerHTML = live.length === 1 ? D.titleOne : D.titleMany;
    var why = document.getElementById('qzWhy');
    why.innerHTML = r.why; why.hidden = !r.why;
    var box = document.getElementById('qzPicks');
    box.innerHTML = '';
    live.forEach(function(k){ box.appendChild(tpl(k).content.cloneNode(true)); });
    var addAll = document.getElementById('qzAddAll');
    addAll.hidden = !live.length;
    addAll.setAttribute('data-mm-add', JSON.stringify(live.map(function(k){ return { id: S[k].id, quantity: 1 }; })));
    show(5);
  }

  document.getElementById('qzGo').addEventListener('click', function(){
    if(!answers[4].length){ var b = this, t = b.textContent; b.textContent = D.pickFirst; setTimeout(function(){ b.textContent = t; }, 1200); return; }
    render();
  });
  document.getElementById('qzRestart').addEventListener('click', function(){
    modal.querySelectorAll('.qz-opt.sel').forEach(function(x){ x.classList.remove('sel'); });
    answers = {1:[],2:[],3:[],4:[]};
    show(1);
  });
  document.getElementById('qzAddAll').addEventListener('click', function(){ setTimeout(close, 50); });
  document.getElementById('qzClose').addEventListener('click', close);
  scrim.addEventListener('click', close);
  document.addEventListener('keydown', function(e){ if(e.key === 'Escape') close(); });

  /* open from [data-quiz] anywhere (except inside other pop-ups, which dispatch mm:open-quiz), #quiz links, or the event */
  document.addEventListener('mm:open-quiz', open);
  document.addEventListener('click', function(e){
    var t = e.target.closest('a[href="#quiz"], [data-quiz]');
    if(!t || t.closest('[data-mm-concern]')) return;
    e.preventDefault(); open();
  });
  if(location.hash === '#quiz') open();
})();
